import { Injectable } from '@angular/core';
import { TreeNode } from '@shared/components/tree-select/Domain/treeNode.model';

@Injectable({ providedIn: 'root' })
export class TreeSelectService {
  findNodesByKeys(nodes: TreeNode[], keys: string[]): TreeNode[] {
    if (!Array.isArray(nodes) || !Array.isArray(keys)) return [];
    return nodes.reduce<TreeNode[]>((acc, node) => {
      if (keys.includes(node.key)) acc.push(node);
      if (node.children?.length) {
        acc.push(...this.findNodesByKeys(node.children, keys));
      }
      return acc;
    }, []);
  }

  filterNodes(nodes: TreeNode[], query: string): TreeNode[] {
    if (!query.trim()) return nodes;

    const normalized = query.toLowerCase();
    return nodes.reduce<TreeNode[]>((acc, node) => {
      const children = node.children ? this.filterNodes(node.children, normalized) : [];
      const isMatch = node.label.toLowerCase().includes(normalized);

      if (isMatch || children.length) {
        acc.push({ ...node, children, expanded: !!children.length });
      }
      return acc;
    }, []);
  }

  expandParentsForSelected(nodes: TreeNode[], selectedKeys: string[]): void {
    const expandNode = (node: TreeNode): boolean => {
      if (!node.children) return selectedKeys.includes(node.key!);

      let shouldExpand = false;
      for (const child of node.children) {
        if (expandNode(child)) {
          shouldExpand = true;
        }
      }

      node.expanded = shouldExpand;
      return shouldExpand || selectedKeys.includes(node.key!);
    };

    nodes.forEach(expandNode);
  }
}
